module.exports = __webpack_public_path__ + "static/showreel2022-bc8561cd77b2b367e3d6acb812f5b746.mp4";